module.exports = __webpack_public_path__ + "img/main_02.6646e0e5.png";